// src/store/venueSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  venues: [],
  page: 1,
  totalCount: 0,
  totalPages: 0,
  scrollY: 0,
};

const venueSlice = createSlice({
  name: "venues",
  initialState,
  reducers: {
    setVenues: (state, action) => {
      state.venues = action.payload;
    },
    addVenues: (state, action) => {
      const newVenues = action.payload;
      const merged = [...state.venues, ...newVenues];
      state.venues = merged.filter(
        (venue, index, self) =>
          index === self.findIndex((v) => v._id === venue._id)
      );
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setScrollY: (state, action) => {
      state.scrollY = action.payload;
    },
    resetVenues: () => initialState,
  },
});

export const {
  setVenues,
  addVenues,
  setPage,
  setTotalCount,
  setTotalPages,
  setScrollY,
  resetVenues,
} = venueSlice.actions;

export default venueSlice.reducer;
